













import {Component, Emit, Prop, Vue, Watch} from "vue-property-decorator";
import { ThreadFirstPost } from "../../Classes/Entities/Chat/ThreadFirstPost";

@Component
export default class TaskThreadOverview extends Vue {
  @Prop() 
  public threadFirstPost!:ThreadFirstPost;

  public created() {
    setTimeout(() => {
      const lastChild:Element|null = document.querySelector('div.l-container div.p-cards--round:last-child');
      if (lastChild != null) {
        lastChild.scrollIntoView(true);
      }
    }, 200)
  }

  @Watch('threadFirstPost.postList.threadList')
  onChange(nw: any, old: any) {
    setTimeout(() => {
      const lastChild:Element|null = document.querySelector('div.l-container div.p-cards--round:last-child');
      if (lastChild != null) {
        lastChild.scrollIntoView(true);
      }
    }, 300)
  }
}
